import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from './';

export const FestivalHeader = ({
  title,
  onSave,
  showSave,
  showAdd,
  addAction,
  addTitle,
  showExit,
  ...props
}) => (
  <div className="mb-4 flex items-center justify-between border-b-[5px] border-[var(--festy-light-gray)]">
    <div>
      <h1 className="font-normal text-[#73797f] [&_svg]:mr-4 [&_svg]:text-[var(--festy-sky-blue)]">
        <FontAwesomeIcon icon={['fas', 'calendar-days']} /> {title}
      </h1>
    </div>
    <div>
      {showExit && (
        <Link className="mr-4 inline-block" to="/">
          <Button>
            <FontAwesomeIcon icon={['fas', 'reply']} /> Dashboard
          </Button>
        </Link>
      )}
      {showSave && (
        <Button onClick={onSave}>
          <FontAwesomeIcon icon={['far', 'save']} /> Save
        </Button>
      )}
      {showAdd && (
        <Button onClick={addAction}>
          <FontAwesomeIcon icon={['far', 'plus']} /> {addTitle}
        </Button>
      )}
    </div>
  </div>
);
